import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TableModule } from 'primeng/table';
import { Subject, takeUntil } from 'rxjs';
import { LocalizationService, LocalizationSettings, LocalizedNumberFormat } from 'src/app/shared/localization/localization.service';
import { ICasePaymentSummary } from 'src/app/shared/models';

@Component({
  selector: 'app-case-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule, TableModule]
})
export class PaymentsComponent implements OnInit,OnChanges {

  @Input() list: ICasePaymentSummary[];
  @Input() language: string;
  @Input() hasInternationalCurrency: boolean;
  @Input() caseCurrencyCode: string;
  @Input() firmCurrencyCode: string;
  @Input() numberFormat: LocalizedNumberFormat;

  private localizationService = inject(LocalizationService);
  private readonly unsubscribe$ = new Subject();

  isEnglish: boolean;
  dateFormat:string = '';

  ngOnInit(): void {
    this.getLocalizationSettings();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.language) {this.isEnglish = this.language.toLocaleLowerCase() == 'en'; }
  }

  private getLocalizationSettings(): void {

    this.localizationService.settings$
      .pipe(
        takeUntil(this.unsubscribe$)
      )
      .subscribe((settings:LocalizationSettings) => {
        this.dateFormat = settings.datePipeFormat;
      });
  }
}


